import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import React from 'react';
import styled from 'styled-components';
var MessageWrap = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 8px 0;\n  width: 85%;\n  max-width: 460px;\n"])));
var Text = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: #dfdfdf;\n  border-radius: 6px;\n  color: #333333;\n  font-size: 14px;\n  line-height: 16px;\n  padding: 16px;\n  white-space: pre-wrap;\n  -webkit-font-smoothing: subpixel-antialiased;\n  word-wrap: break-word;\n"])));
var SenderInfo = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: #616161;\n  font-size: 11px;\n  margin: 4px 16px;\n"])));

function ChatMessage(props) {
  var message = props.message,
      user = props.user,
      self = props.self,
      time = props.time,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return /*#__PURE__*/React.createElement(MessageWrap, {
    style: style,
    className: "messageAreaWrap"
  }, /*#__PURE__*/React.createElement(Text, {
    style: self ? {
      backgroundColor: '#4e8cff',
      color: '#ffffff'
    } : {}
  }, message.message), /*#__PURE__*/React.createElement(SenderInfo, null, message.User.firstName, " ", message.User.lastName, " - ", time));
}

export default ChatMessage;